import styled from "styled-components";

export const CheckBoxGroupDiv = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  .checkBoxGroup__option {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
  }
  .checkBoxGroup__option > input {
    margin-right: 10px;
  }
`;
